import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet';

import {
  createNewsSeoData,
} from '../../utils/newsSeo';

const NewsSeo = ({
  news,
  authorId,
}) => {
  const seo = useMemo(
    () =>
      createNewsSeoData(
        news,
        authorId
      ),
    [news, authorId]
  );

  return (
    <Helmet>
      <html lang="uk" />

      <title>{seo.title}</title>

      <meta
        name="description"
        content={seo.description}
      />

      <meta
        name="robots"
        content="index, follow, max-image-preview:large"
      />

      <link
        rel="canonical"
        href={seo.canonicalUrl}
      />

      <meta
        property="og:type"
        content="article"
      />

      <meta
        property="og:site_name"
        content="BigSPORT"
      />

      <meta
        property="og:locale"
        content="uk_UA"
      />

      <meta
        property="og:title"
        content={news.title}
      />

      <meta
        property="og:description"
        content={seo.description}
      />

      <meta
        property="og:url"
        content={seo.canonicalUrl}
      />

      <meta
        property="og:image"
        content={seo.image}
      />

      <meta
        property="og:image:alt"
        content={news.title}
      />

      {seo.datePublished && (
        <meta
          property="article:published_time"
          content={seo.datePublished}
        />
      )}

      {seo.dateModified && (
        <meta
          property="article:modified_time"
          content={seo.dateModified}
        />
      )}

      {news.author && (
        <meta
          property="article:author"
          content={news.author}
        />
      )}

      {news.category && (
        <meta
          property="article:section"
          content={news.category}
        />
      )}

      {Array.isArray(news.tags) &&
        news.tags.map((tag) => (
          <meta
            key={tag}
            property="article:tag"
            content={tag}
          />
        ))}

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={news.title}
      />

      <meta
        name="twitter:description"
        content={seo.description}
      />

      <meta
        name="twitter:image"
        content={seo.image}
      />

      <meta
        name="twitter:image:alt"
        content={news.title}
      />

      <script type="application/ld+json">
        {JSON.stringify(seo.articleSchema)}
      </script>

      <script type="application/ld+json">
        {JSON.stringify(seo.breadcrumbSchema)}
      </script>
    </Helmet>
  );
};

export default NewsSeo;